import { Observable } from 'rxjs';
import {
  GroupMultiselectItem,
  SelectedGroupMultiselectItem,
} from '../shared/components/group-multiselect-dropdown/group-multiselect-dropdown.component';
import { MultiSelectItem } from '../shared/components/multi-select/multi-select.component';

//Enum Start region
export enum ServiceOrderStatus {
  None = 'None',
  Requested = 'Requested',
  Ordered = 'Ordered',
  Received = 'Received',
  Delivered = 'Delivered',
  Completed = 'Completed',
  Pending = 'Pending',
  Review = 'Review',
}

export enum Controls {
  Name = 'name',
  Country = 'country',
  Building = 'building',
  Floors = 'floors',
  FindASpaceTab = 'findASpaceTab',
  MeetingsTab = 'meetingsTab',
  BookingsTab = 'bookingsTab',
  ServiceOrdersTab = 'serviceOrdersTab',
  CalendarTab = 'calendarTab',
  IsActive = 'isActive',
  IsFavourite = 'isFavourite',
}
export enum FindASpaceTabControls {
  SpaceFeatures = 'spaceFeatures',
  Category = 'category',
  Type = 'type',
  Capacity = 'capacity',
}
export enum MeetingsTabControls {
  DashboardRequestType = 'dashboardRequestType',
  DashboardStatus = 'dashboardStatus',
  DashboardMeetingType = 'dashboardMeetingType',
  MeetingRequestType = 'meetingRequestType',
  MeetingStatus = 'meetingStatus',
  VirtualMeetingStatus = 'virtualMeetingStatus',
  UnfulfilledSpaceType = 'unfulfilledSpaceType',
}

export enum BookingsTabControls {
  ServiceOrders = 'serviceOrders',
  SpaceType = 'spaceType',
  MeetingType = 'meetingType',
  DashboardStatus = 'dashboardStatus',
  WaitListStatus = 'waitListStatus',
}
export enum ServiceOrdersTabControls {
  Type = 'type',
  ServiceOrder = 'serviceOrder',
  Status = 'status',
  VirtualServiceOrders = 'virtualServiceOrders',
  VirtualStatus = 'virtualStatus',
  InOfficeIncludeDelete = 'inOfficeIncludeDelete',
  VirtualIncludeDelete = 'virtualIncludeDelete',
}
export enum CalendarTabControls {
  RoomType = 'roomType',
  Capacity = 'capacity',
  SpaceFeatures = 'spaceFeatures',
}

export enum ServiceOrderCategory {
  Catering = 'catering',
  TaskType = 'TaskType',
}

export enum MeetingDashboardStatus {
  Requested = 'Requested',
  Tentative = 'Tentative',
  Pipeline = 'Pipeline',
  Definite = 'Definite',
  Cancelled = 'Cancelled',
  DidNotMaterialize = 'Did Not Materialize',
  NewRequest = 'New Request',
}
export enum LocalStorageKey {
  FavoriteView = 'FavoriteView',
  SelectedView = 'SelectedView',
}
export enum QueryParams {
  SelectedViewId = 'viewId',
}

export enum PreferencesTabContent {
  FindASpace = 'findASpaceTab',
  Calendar = 'calendarTab',
  Meetings = 'meetingsTab',
  Bookings = 'bookingsTab',
  ServiceOrders = 'serviceOrdersTab',
}
export enum ReservationClassification {
  SingleOffice,
  Virtual,
  Hybrid,
}
// Enum End Region

// Constants Start Region

export const PREFERENCES_TABS: NgxTab[] = [
  {
    title: 'Translation.Fas',
    content: PreferencesTabContent.FindASpace,
  },
  {
    title: 'Translation.Calendar',
    content: PreferencesTabContent.Calendar,
  },
  {
    title: 'Translation.Meetings',
    content: PreferencesTabContent.Meetings,
  },
  {
    title: 'Translation.Bookings',
    content: PreferencesTabContent.Bookings,
  },
  {
    title: 'Translation.Serviceorders',
    content: PreferencesTabContent.ServiceOrders,
  },
];
export const TAB_NAME_ADAPTER = {
  FAS: Controls.FindASpaceTab,
  Calendar: Controls.CalendarTab,
  Meetings: Controls.MeetingsTab,
  Bookings: Controls.BookingsTab,
  'Service orders': Controls.ServiceOrdersTab,
};

export const FIELD_PROPERTY_ADAPTER = {
  FAS: {
    'Space features': FindASpaceTabControls.SpaceFeatures,
    'Space type': FindASpaceTabControls.Type,
    Capacity: FindASpaceTabControls.Capacity,
  },
  Calendar: {
    'Space features': CalendarTabControls.SpaceFeatures,
    'Space type': CalendarTabControls.RoomType,
    Capacity: CalendarTabControls.Capacity,
  },
  Meetings: {
    'Meetings Dashboard': {
      'Meeting request type': MeetingsTabControls.DashboardRequestType,
      Status: MeetingsTabControls.DashboardStatus,
      'Meeting type': MeetingsTabControls.DashboardMeetingType,
    },
    'In-office meeting Requests': {
      'Request type': MeetingsTabControls.MeetingRequestType,
      Status: MeetingsTabControls.MeetingStatus,
    },
    'Virtual meeting Requests': {
      Status: MeetingsTabControls.VirtualMeetingStatus,
    },
    'Unfulfilled team requests': {
      'Space type': MeetingsTabControls.UnfulfilledSpaceType,
    },
  },
  Bookings: {
    'All bookings': {
      'Service orders': BookingsTabControls.ServiceOrders,
      'Space type': BookingsTabControls.SpaceType,
      'Meeting type': BookingsTabControls.MeetingType,
      Status: BookingsTabControls.DashboardStatus,
    },
    Waitlist: {
      Status: BookingsTabControls.WaitListStatus,
    },
  },
  'Service orders': {
    'In-office': {
      Type: ServiceOrdersTabControls.Type,
      'Service orders': ServiceOrdersTabControls.ServiceOrder,
      Status: ServiceOrdersTabControls.Status,
      'Include Deleted': ServiceOrdersTabControls.InOfficeIncludeDelete,
    },
    Virtual: {
      'Service orders': ServiceOrdersTabControls.VirtualServiceOrders,
      Status: ServiceOrdersTabControls.VirtualStatus,
      'Include Deleted': ServiceOrdersTabControls.VirtualIncludeDelete,
    },
  },
};

export const MASTER_VIEW_ID = '1';
export const ALL_SELECTED = [{ value: 'All', name: 'All', all: true }];
export const ALL_SELECTED_ServiceOrders = [{ id: 0, label: 'All' }];
export const ALL_SELECTED_Value = [-1];

export const BOOKING_RESERVATION_STATUS = [
  {
    value: 'AwaitingCheckIn',
    name: '',
  },
  {
    value: 'CheckedIn',
    name: '',
  },
  {
    value: 'Reserved',
    name: '',
  },
  {
    value: 'PendingApproval',
    name: '',
  },
];

export const MEETING_DASHBOARD_STATUS = [{ value: MeetingDashboardStatus.Definite, name: '' }];

export const WAITLIST_STATUS = [{ value: 'Active', name: '' }];
export const CAPACITY_VALUE = 1;
export const FIND_A_SPACE_CATEGORY = 'Individual';

export const SERVICE_ORDER_STATUS = [
  { value: ServiceOrderStatus.Requested, name: '' },
  { value: 'Empty', name: '' },
];
export const SERVICE_ORDER_VIRTUAL_STATUS = [{ value: ServiceOrderStatus.Requested, name: '' }];
export const RECORDS_PER_PAGE = 40;
export const MEETING_REQUESTED_TYPE = [{ name: '', value: ServiceOrderStatus.Requested }];
export const ClassificationTypeMultiLingual = new Map<string, string>([
  [ReservationClassification[ReservationClassification.SingleOffice], 'Translation.SingleOffice'],
  //Phase 1- Virtual option is not required
  // [ReservationClassification[ReservationClassification.Virtual], 'Translation.Virtual'],
    [ReservationClassification[ReservationClassification.Hybrid], 'Translation.Hybrid']
]);
// Constants End Region

// Interface Start Region
export interface ServiceOrderDTO {
  id: number;
  shortDescription: string;
  serviceOrderCategory: ServiceOrderCategory;
}
export interface NgxTab {
  title: string;
  content: string;
}
export interface PreferencesTabConfigDTO {
  id: number;
  name: string;
  tabFields: PreferencesTabFieldDTO[];
  subTabs: PreferencesSubTabFieldDTO[];
}

export interface PreferencesTabFieldDTO {
  id: number;
  name: string;
}

export interface PreferencesSubTabFieldDTO {
  name: string;
  tabFields: PreferencesTabFieldDTO[];
  includeDelete?: boolean;
}
export interface ReservationStatus {
  DisplayOrder: number;
  EMSStatusID: number;
  Value: string;
  IsActiveStatus: boolean;
}

export interface PreferencesControlsConfig {
  findASpaceTab?: Partial<{ [key in FindASpaceTabControls] }>;
  calendarTab?: Partial<{ [key in CalendarTabControls] }>;
  meetingsTab?: Partial<{ [key in MeetingsTabControls] }>;
  bookingsTab?: Partial<{ [key in BookingsTabControls] }>;
  serviceOrdersTab?: Partial<{ [key in ServiceOrdersTabControls] }>;
}

export interface SelectOption {
  name: string;
  value: any;
  all?: boolean;
  disabled?: boolean;
  groupText?: string;
  items?: Omit<SelectOption, 'items'>[];
  icon?: string;
}

export interface MultiSelectExtendOption {
  disabled?: boolean;
  items?: Omit<SelectOption, 'items'>[];
}

export interface PreferenceBody {
  id?: string;
  isFavourite: boolean;
  isActive: boolean;
  name: string;
  // countries: string;
  buildings: string;
  floors: string;
  recordsPerPage: string;
  assignedToMe: boolean;
  revision?: number;
  tabFields: { tabFieldId: number; value: string }[];
}

export interface PreferenceDetails {
  id: string;
  isFavourite: boolean;
  isActive: boolean;
  name: string;
  // countries: string;
  buildings: string;
  floors: string;
  recordsPerPage: number;
  assignedToMe: boolean;
  viewDetails: ViewDetail[];
  revision: number;
  allViews: AllViewItem[];
}

export interface ViewDetail {
  tabFieldId: number;
  value: string;
}

export interface AllViewItem {
  id: string;
  name: string;
  isActive: boolean;
  isFavourite: boolean;
  isNew?: boolean;
}

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

export interface PreferenceBody {
  id?: string;
  isFavourite: boolean;
  isActive: boolean;
  name: string;
  //countries: string;
  buildings: string;
  floors: string;
  recordsPerPage: string;
  assignedToMe: boolean;
  revision?: number;
  tabFields: { tabFieldId: number; value: string }[];
}

export interface AllViewItem {
  id: string;
  name: string;
  isActive: boolean;
  isFavourite: boolean;
  isNew?: boolean;
}
export interface ViewDetail {
  tabFieldId: number;
  value: string;
}
export interface Country {
  id: number;
  name: string;
  code: number;
}
export interface PreferenceViewRequest {
  userId: number;
  viewId: string;
}

export interface UserViewsRequest {
  userId: number;
}

//DTO Region STart
export interface PreferenceViewDetailsDTO {
  viewId: string;
  viewName: string;
  isFavourite: boolean;
  isActive: boolean;
  country: number[];
  buildingDetails: PreferencesBuildingDetailsDTO[];
  floorDetails: PreferencesFloorsDTO[];
  fasFilters: PreferencesFindASpaceDTO;
  calendar: PreferencesCalendarDTO;
  Meetingdashboard: PreferencesMeetingDashboardDTO;
  Bookingdashboard: PreferencesMeetingDashboardDTO;
  ServiceOrder: PreferencesServiceOrderDTO;
}

export interface PreferencesBuildingDetailsDTO {
  BuildingId: number;
  BuildingName: string;
}

// tslint:disable-next-line:no-empty-interface
export interface PreferencesFloorsDTO {}

export interface PreferencesFindASpaceDTO {
  Spacefeatures: number[];
  category: number;
  Type: number;
  Allocation: number;
  duration: number;
  Aminities: number[];
  otherspace: number[];
}

export interface PreferencesCalendarDTO {
  spaceType: number;
  capacity: number;
}

export interface PreferencesMeetingDashboardDTO {}

export interface PreferencesBookingDashboardDTO {
  Type: number[];
  MeetingType: number[];
  Status: number[];
  WaitlistStatus: number[];
}

export interface PreferencesServiceOrderDTO {
  Type: number[];
  ServiceOrders: number[];
  Status: SelectOption[];
  TypeOfTechonology: number[];
  VirtualServiceOrders: number[];
  VirtualStatus: SelectOption[];
}

/*Preferences tiles list*/
// export interface PreferencesViewsDTO {
//   viewId: string;
//   ViewName: string;
//   isActive: number;
//   isFavourite: number;
//   buildingDetails: PreferencesBuildingDetailsDTO;
// }
// export interface FavoriteViewDTO {
//   id: string;
//   isFavourite: boolean;
//   isActive: boolean;
//   name: string;
//   countries: string;
//   buildings: string;
//   floors: string;
//   recordsPerPage: number;
//   assignedToMe: boolean;
//   revision: number;
//   viewDetails: ViewDetailDTO[];
//   allViews: AllViewItemDTO[];
// }

// export interface ViewDetailDTO {
//   tabField: number;
//   value: string;
// }

// export interface AllViewItemDTO {
//   id: string;
//   name: string;
//   isActive: boolean;
//   isFavourite: boolean;
// }

export interface BuildingDTO {
  id: number;
  addressShort: string;
  cafeteriaAvailable: boolean;
  cateringRequestAvailable: boolean;
  city: string;
  country: string;
  displayName: string;
  enabledInDGuest: boolean;
  timeZoneIanaName: string;
  timeZoneOffSet: number;
  timeZoneShortName: string;
  timeZoneStandardName: string;
  floors: FloorDTO[];
}

export interface FloorDTO {
  uniqueKey: number;
  name: string;
  description: string;
  favorite: boolean;
}

//DTO Region End
// Interface End Region

// Class Start Region
export class PreferencesBookingsData {
  constructor(
    public serviceOrders: SelectOption[] = ALL_SELECTED,
    public spaceType: SelectOption[] = ALL_SELECTED,
    public meetingType: SelectOption[] = ALL_SELECTED,
    public status: string[] = BOOKING_RESERVATION_STATUS.map((i) => i.value),
    public waitListStatus: string[] = WAITLIST_STATUS.map((i) => i.value)
  ) {}
}

export class PreferencesFindASpaceData {
  constructor(public spaceFeatures: Number[] = [], public capacity: number = CAPACITY_VALUE, public type = '') {}
}

export class PreferencesCalendarData {
  constructor(public roomType: Number[] = [-1], public spaceFeatures: number[] = [], public capacity: number = CAPACITY_VALUE) {}
}

export class PreferencesMeetingsData {
  constructor(
    public dashboardRequestType: SelectOption[] = ALL_SELECTED,
    public dashboardMeetingType: SelectOption[] = ALL_SELECTED,
    public dashboardStatus: string[] = MEETING_DASHBOARD_STATUS.map((i) => i.value),
    public inOfficeRequestType: SelectOption[] = ALL_SELECTED,
    public inOfficeStatus: string[] = MEETING_REQUESTED_TYPE.map((i) => i.value),
    public virtualMeetingRequestStatus: string[] = MEETING_REQUESTED_TYPE.map((i) => i.value),
    // public waitlistStatus: SelectOption[] = ALL_SELECTED,
    public unfulfilledTeamRequestsSpaceType: SelectOption[] = ALL_SELECTED
  ) {}
}

export class PreferencesServiceOrdersData {
  constructor(
    public inOfficeType: SelectOption[] = ALL_SELECTED,
    public inOfficeServiceOrders: SelectedGroupMultiselectItem[] = ALL_SELECTED_ServiceOrders,
    public inOfficeStatus: string[] = SERVICE_ORDER_STATUS.map((i) => i.value),
    public virtualServiceOrders: SelectOption[] = ALL_SELECTED,
    public virtualStatus: string[] = SERVICE_ORDER_VIRTUAL_STATUS.map((i) => i.value),
    public inOfficeIncludeDelete: boolean = false,
    public virtualIncludeDelete: boolean = false
  ) {}
}

export class PreferencesViewData {
  constructor(
    public viewId: string = '',
    public viewName: string = '',
    public isFavourite: boolean = false,
    public isActive: boolean = true,
    // public country: Number[] = [],
    public building: SelectOption[] = [],
    public floors: SelectedGroupMultiselectItem[] = [],
    public assignedToMe: boolean = true,
    public recordsPerPage: number = RECORDS_PER_PAGE,
    public revision: number = 0,
    public findASpaceTab: PreferencesFindASpaceData = new PreferencesFindASpaceData(),
    public calendarTab: PreferencesCalendarData = new PreferencesCalendarData(),
    public meetingsTab: PreferencesMeetingsData = new PreferencesMeetingsData(),
    public bookingsTab: PreferencesBookingsData = new PreferencesBookingsData(),
    public serviceOrdersTab: PreferencesServiceOrdersData = new PreferencesServiceOrdersData(),
    public allViews: AllViewItem[] = []
  ) {}
}

// Class End Region
